import { createSlice } from '@reduxjs/toolkit';

const initialState = null;

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    saveErrorMsg: (state, action) => {
      state = action.payload;
      return state;
    },
    clearErrorMsg: (state) => (state = null),
  },
});

export const { saveErrorMsg, clearErrorMsg } = errorSlice.actions;

export default errorSlice.reducer;
